<div class="CalendarEntry">
	<p *ngIf="DayNumber != -1" style="text-align: right">{{ DayNumber }}</p>

	<div *ngIf="DayNumber != -1" class="OpenDisplay">
		<label>Open: </label>
		<input class="form-control" type="checkbox" (ngModelChange)="onOpenChange($event)" [(ngModel)]="IsOpen" />
	</div>
</div>
